import { Switch } from "antd";
import { useState } from "react";
import KeyIcon from "../../assets/icons/KeyIcon";
import UserIcon from "../../assets/icons/UserIcon";
import profilePic from "../../assets/images/avatar-image.png";
import InfoItem from "../common/InfoItem";
import InfoTitle from "../common/InfoTitle";

export default function ContactInfo() {
  const [status, setStatus] = useState(true);
  return (
    <>
      <div className="bg-white rounded-md border border-extra-light p-6 max-h-[546px]">
        <InfoTitle className="mb-6" icon={<UserIcon />}>
          Employee Info
        </InfoTitle>

        <div className="w-full">
          <div className="w-24 h-24">
            <img
              className="w-full h-fuw-full rounded-full"
              src={profilePic}
              alt="..."
            />
          </div>
        </div>

        <div className="mt-4">
          <div
            className={`flex justify-between items-center border-b  py-2 border-extra-light`}
          >
            <h4 className={`text-extra-gray font-medium `}>Status</h4>

            <div className={`font-medium text-display-body`}>
              <Switch checked={status} onChange={(val) => setStatus(val)} />
              <span className="ml-1">{status ? "Active" : "Inactive"}</span>
            </div>
          </div>

          <InfoItem title="Company Name" children="Elevate Digital Agency" />
          <InfoItem
            title="Company Email"
            children="bakerhossain.cse@gmail.com"
          />
          <InfoItem title="Mobile No." children="+8801736398503" />
          <InfoItem title="Representative " children="Md Baker Hossain" />
          <InfoItem
            title="Joining Date"
            children="Nov 06, 2024 | 2 Month Ago"
          />
          <InfoItem
            title="Location"
            children="House 11, Road 21, Block C, Section 10, Mirpur, Dhaka-1216"
            className="font-normal"
          />

          <div
            className={`flex justify-between items-center  py-2 border-extra-light`}
          >
            <h4 className={`text-extra-gray font-medium `}>Password Reset</h4>

            <div className="flex items-center gap-x-1 rounded-md py-[6px] px-3 font-medium cursor-pointer border-2 text-primary border-primary border-solid ">
              <KeyIcon />
              <span>Password Reset</span>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
